import { mnemoService, proxyApiMnemo } from '.';
import {proxyBE} from './common';

export const certificationRequestService = {    
   
    getPendingRequest(orderNumber){
        return proxyBE.get(`certificationRequest/pending-request/${orderNumber}`);
    },
  
    updateRequestStep(payload){
        return proxyBE.put('certificationRequest/updateStep', payload);        
    },

    prepareSign(requestId){
        return proxyBE.put('certificationRequest/prepare-sign', {requestId});
    },

    postSign(payload){
        return proxyBE.put('certificationRequest/post-sign', payload);
    },

    getRequestMNEMO(orderNumber) {
        const payload = mnemoService.buildPayload('getRequest', 'registrationCode', orderNumber);
        return proxyApiMnemo.get('certificationRequest/?payload='+encodeURI(payload));
    },     

    downloadTitle(registrationCode, requestID){
        const payload = mnemoService.buildPayloadObject('downloadTitle', {registrationCode, requestID });
        return proxyApiMnemo.get('certificationRequest/?payload='+encodeURI(payload));
    }
}